import { FormGroup } from '@angular/forms';

export function isKeyOf<T extends object>(
  key: PropertyKey,
  obj: T
): key is keyof T {
  return key in obj;
}

export type CryptoUUID = `${string}-${string}-${string}-${string}-${string}`;

/** Utility type to extract raw value types from a FormGroup */
export type FormGroupRawValue<T extends FormGroup> = {
  [K in keyof T['controls'] as undefined extends T['controls'][K]
    ? never
    : K]: T['controls'][K] extends { value: infer V }
    ? V
    : T['controls'][K]['value'];
} & {
  [K in keyof T['controls'] as undefined extends T['controls'][K]
    ? K
    : never]?: T['controls'][K] extends { value: infer V }
    ? V
    : T['controls'][K]['value'];
};

export function isNil(value: unknown): value is null | undefined {
  return value === null || value === undefined;
}
